(function($) {

	'use strict';

	var init = function() {

        initCustomCSSFileInput();

    };

    var initCustomCSSFileInput = function() {
        // With Gravity Form
        $(document).bind('gform_post_render', function(){
            initListener();
            isEmpty();      
        });
    
        initListener();
        isEmpty();  
    };
    
    var initListener = function() {
        $('.ginput_container_fileupload').on('click', uploadFile);
        $('.ginput_container_fileupload input[type="file"]').change(function(e){
            var input = $(e.target);
            var container = input.parents('.gfield');
            if(input.val().length > 0){
                var name = input.val().split('\\').slice(-1)[0] ;
                updateFileName(container, name);
            } else {
                removeFile(container);
            }
            isEmpty();
        });    
    }
    
    var removeFile = function(container){
        container.find('.filename').remove();
        container.find('input[type="file"]').val("");
        isEmpty();
    }

    var isEmpty = function() {
        $('input[type="file"]').each(function() {
            if($(this).val() == '') {
                $(this).parent().addClass('is-empty');
            } else {
                $(this).parent().removeClass('is-empty');
            }
        });
    }

    var updateFileName = function(container, name){
        if(container.children('.filename').length == 0){
            var removeDOM = $("<div class='filename__remove'></div>").click(function(e){
                removeFile($(e.target).parents('.gfield'));
            });
            var filenameDOM = $("<div class='filename'>"+name+"</div>");
            filenameDOM.append(removeDOM);
            container.append(filenameDOM);
        } else{
            container.children('.filename')
                .contents().filter(function() {
                    return (this.nodeType === Node.TEXT_NODE && this.nodeValue.trim() !== "");
                })
                .first()
                .replaceWith(name);
        }
    }
    
    var uploadFile = function(e){
        var el = $(e.target);
        if( el.hasClass('ginput_container_fileupload') ){
            el.children("input[type='file']").click();
        }
    }
    
	$(document).ready(function() {
		init();
    });

})(jQuery);